import { Box, type BoxProps } from '@/ui';

export const Shape = (props: BoxProps) => {
  return (
    <Box
      _groupHover={{ bg: 'rgba(113, 106, 221, 0.20)' }}
      bg="rgba(150, 150, 150, 0.20)"
      borderRadius="2px"
      sx={{ '.active &': { bg: 'rgba(113, 106, 221, 0.20)' } }}
      {...props}
    />
  );
};
